import { AnnotationStatusBadge } from "../AnnotationStatusBadge/AnnotationStatusBadge";
import type { EvalAnnotation } from "../../types";
import styles from "./AnnotationHistoryList.module.css";

export interface AnnotationHistoryListProps {
  items: EvalAnnotation[];
  selectedAnnotationId?: string;
  onSelect: (annotationId: string) => void;
}

export function AnnotationHistoryList({
  items,
  selectedAnnotationId,
  onSelect,
}: AnnotationHistoryListProps) {
  if (items.length <= 1) {
    return null;
  }

  return (
    <div className={styles.list} data-testid="annotation-history-list">
      <h3 className={styles.title}>Annotation history</h3>
      <ul className={styles.items}>
        {items.map((item) => {
          const isSelected = item.annotation_id === selectedAnnotationId;

          return (
            <li key={item.annotation_id}>
              <button
                type="button"
                className={isSelected ? styles.itemSelected : styles.item}
                onClick={() => onSelect(item.annotation_id)}
                aria-pressed={isSelected}
              >
                <span className={styles.itemId}>{item.annotation_id}</span>
                <AnnotationStatusBadge status={item.status} />
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
